export enum DonateToolPaymentTypes {
  SINGLE = "single",
  RECURRING_DD = "recurringDd",
  RECURRING_CARD = "recurringCard",
}
